
// => Styling
import styles from './StartView.module.css';

// => Components
import MenuItem from './components/MenuItem';

// => Data
import { menuItems } from '../../content/menuItems';

// => React hooks
import { useState, useRef } from 'react';


// ============
// Component
// ============
const StartView = ({
    onRegular,
    onSettings,
    onShop,
}) => {

    const [selectedItem, setSelectedItem] = useState(null)

    const isSelected = (i) => {
        return selectedItem === i
    }

    const initialized = useRef(false)
    if (!initialized.current) {
        initialized.current = true
        
        /* Set click functions for menu items
        -------------------------------------- */
        // Regular
        menuItems[0].onClick = onRegular
        // Shop
        menuItems[2].onClick = onShop
        // Settings
        menuItems[3].onClick = onSettings
    }

    function selectItem(index) {
        if (isSelected(index)) return
        setSelectedItem(index)
    }

    function clickItem(index) {
        menuItems[index].onClick()
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            {/* Menu container */}
            <div className={styles.menu}>
                {menuItems.map((e, index) =>
                    <MenuItem key={"menu-item_"+index}
                            index={index}
                            isSelected={isSelected(index)}
                            onSelected={(i)=>selectItem(i)}
                            title={e.title}
                            desc={e.desc}
                            clip={e.clip}
                            icon={e.icon}
                            onClicked={(i)=>clickItem(i)}
                            color={e.color}
                            locked={e.locked} />
                )}
            </div>

        </div>
    );
}


export default StartView